import React from 'react';

export const SvgPlanet: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M1 9C1 10.0506 1.20693 11.0909 1.60896 12.0615C2.011 13.0321 2.60028 13.914 3.34315 14.6569C4.08601
       15.3997 4.96793 15.989 5.93853 16.391C6.90914 16.7931 7.94943 17 9 17C10.0506 17 11.0909 16.7931 12.0615
        16.391C13.0321 15.989 13.914 15.3997 14.6569 14.6569C15.3997 13.914 15.989 13.0321 16.391 12.0615C16.7931
         11.0909 17 10.0506 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827
          1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.5332 6.3335H16.4665" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.5332 11.6665H16.4665" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.55505 1C7.05757 3.39966 6.26367 6.17144 6.26367 9C6.26367 11.8286 7.05757 14.6003 8.55505 17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.44434 1C10.9418 3.39966 11.7357 6.17144 11.7357 9C11.7357 11.8286 10.9418 14.6003 9.44434 17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};
